export const CREATE = {
  REQUEST: 'AdditionalServiceRequest/Create/Request',
  SUCCESS: 'AdditionalServiceRequest/Create/Success',
  FAILURE: 'AdditionalServiceRequest/Create/Failure'
};

export const CREATE_CUSTOM = {
  REQUEST: 'AdditionalServiceRequest/CreateCustom/Request',
  SUCCESS: 'AdditionalServiceRequest/CreateCustom/Success',
  FAILURE: 'AdditionalServiceRequest/CreateCustom/Failure'
};
